module.exports = __webpack_public_path__ + "img/individualConfig.22dcabbc.svg";